import React from 'react';
import Modal from 'react-bootstrap/Modal';

import AuthMethodButtons from '@components/AuthMethodButtons/AuthMethodButtons';
import Button from '@components/Button';

import { AuthScreen, useAuthManagerContext } from '@private-crm-app/auth-manager-context';
import { useAgencyFlags } from '@private-crm-app/hooks/useAgencyFlags';

import './style.scss';

interface IFollowAuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  redirectScreen?: AuthScreen;
}

const FollowAuthModal: React.FC<IFollowAuthModalProps> = ({ isOpen, onClose, redirectScreen = AuthScreen.LISTING }) => {
  const { signup, signupWithPhone, loginWithApple, loginWithGoogle } = useAuthManagerContext();
  const { flags } = useAgencyFlags();

  const handleEmail = () => signup(redirectScreen);
  const handlePhone = () => signupWithPhone(redirectScreen);
  const handleApple = () => loginWithApple(redirectScreen, flags.appleAuth0ConnectionName || undefined);
  const handleGoogle = () => loginWithGoogle(redirectScreen);
  const isAppleSignInEnabled =
    flags.isAccountsFeatureFlagEnabled && flags.isMobileAppEnabled && !!flags.appleAuth0ConnectionName;
  const authMethodCopy = isAppleSignInEnabled ? 'Email, Phone, Google, or Apple' : 'Email, Phone, or Google';

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="follow-auth-modal"
      dialogClassName="follow-auth-modal__dialog"
    >
      <Modal.Body className="follow-auth-modal__body">
        <h2 className="follow-auth-modal__title">Create An Account to Follow Requests</h2>
        <p className="follow-auth-modal__subtitle">Use {authMethodCopy} to get started.</p>

        <div className="follow-auth-modal__buttons">
          <Button
            onClick={handleEmail}
            bsStyle={ButtonStyle.PRIMARY}
            content="Continue with Email"
            className="follow-auth-modal__button follow-auth-modal__button--email"
          />

          <div className="follow-auth-modal__divider">
            <span>OR</span>
          </div>

          <AuthMethodButtons
            onPhone={handlePhone}
            onGoogle={handleGoogle}
            onApple={handleApple}
            showApple={isAppleSignInEnabled}
            className="follow-auth-modal__secondary-buttons"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FollowAuthModal;
